import { render } from "./InputBack.vue?vue&type=template&id=616519e2&scoped=true"
import script from "./InputBack.vue?vue&type=script&lang=js"
export * from "./InputBack.vue?vue&type=script&lang=js"

import "./InputBack.vue?vue&type=style&index=0&id=616519e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616519e2"]])

export default __exports__